<script setup lang="ts">

import HomeChartTitle from '~/components/@pages/home/HomeChartTitle.vue'
import IconTooltip from '~/components/tooltip/IconTooltip.vue'
import BcLabelContainer from '~/ui/LabelContainer/BcLabelContainer.vue'
import { hexToRGB } from '~/utils/color'

interface IProps {
  icon: string
  label: string
  value: string
  color: string
  unit?: string
  tooltip?: string
}

const props = defineProps<IProps>()

const bgColor = hexToRGB(props.color, 0.1)

</script>

<template>
  <div>
    <Card class="h-20 p-4">
      <div class="flex gap-x-4">
        <div class="item">
          <FontAwesomeIcon
            :icon="icon"
            :color="props.color"
            class="text-2xl"
          />
        </div>
        <div class="flex flex-col justify-between">
          <HomeChartTitle
            :title="label"
            :tooltip="tooltip"
            class="text-base"
          />
          <div>
            <span class="text-xl text-primary">{{ props.value }}</span> <span
              v-if="props.unit"
              class="ml-1 text-primary/40"
            >{{ props.unit }}</span>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<style scoped>
.item {
  @apply flex w-12 h-12 p-2 rounded-lg items-center justify-center;
  background-color: v-bind(bgColor);
}
</style>